import { Box, Button, Icon, Link, Tag, Text, Title } from '@factorialco/deprecated-design-system'
import BudgetsColaborationImage from 'assets/images/budgets/budgets-collaboration.jpg'
import BudgetsEmpowerTeamsImage from 'assets/images/budgets/budgets-empower-teams.jpg'
import BudgetsEmptyImage from 'assets/images/budgets/budgets-empty.jpg'
import BudgetsPlanAndControlImage from 'assets/images/budgets/budgets-plan-and-control.jpg'
import BudgetsVisibilityImage from 'assets/images/budgets/budgets-visibility.jpg'

import { useEffect } from 'modules/core/hooks/useEffect'
import { useNavigation } from 'modules/core/hooks/useNavigation'
import { track } from 'modules/core/lib/Tracking'
import helpCenterUrl from 'modules/core/lib/helpCenterUrl'
import i18n from 'modules/core/lib/i18n'

import { events } from 'modules/finance/lib/events'

import HalfWidthBlock from './HalfWidthBlock'

interface TitleWrapperProps {
  children: React.ReactNode
}

const handleButtonClick = () => {
  track(events.budgetsLandingCtaClicked)
}

const Banner = () => {
  return (
    <Box inline maxWidth="fit-content">
      <Tag type="correct">{i18n.t('budgets.landing.real_time_block.banner')}</Tag>
    </Box>
  )
}

const TitleWrapper = ({ children }: TitleWrapperProps) => {
  return (
    <Box paddingRight="s64" gap="s16">
      {children}
    </Box>
  )
}

const BudgetsLanding = () => {
  const { navigation } = useNavigation()
  const HELP_CENTER_URL = helpCenterUrl('budgets_landing')

  useEffect(() => {
    track(events.viewBudgetsLanding)
  }, [])

  return (
    <Box justifyContent="center" alignItems="center" gap="s32">
      <HalfWidthBlock
        content={
          <TitleWrapper>
            <Banner />
            <Title
              title={i18n.t('budgets.landing.real_time_block.title')}
              description={i18n.t('budgets.landing.real_time_block.description')}
            />
            <Button.Router
              to={navigation.expenses.budgets.list.new.fullPath()}
              onClick={handleButtonClick}
            >
              {i18n.t('budgets.landing.real_time_block.cta')}
            </Button.Router>
          </TitleWrapper>
        }
        content2={<img src={BudgetsEmptyImage} alt="" aria-hidden="true" />}
      />
      <Box flexDirection="row" gap="s80" textAlign="center">
        <Title
          variant="500"
          title={i18n.t('budgets.landing.create_budget_block.title')}
          description={i18n.t('budgets.landing.create_budget_block.description')}
          illustration="finance-shopping-abacus"
          centered
        />
        <Title
          variant="500"
          title={i18n.t('budgets.landing.spenders_block.title')}
          description={i18n.t('budgets.landing.spenders_block.description')}
          illustration="add-user"
          centered
        />
        <Title
          variant="500"
          title={i18n.t('budgets.landing.track_block.title')}
          description={i18n.t('budgets.landing.track_block.description')}
          illustration="performance"
          centered
        />
      </Box>
      <Box
        flexDirection="column"
        gap="s32"
        alignItems="center"
        justifyContent="center"
        paddingTop="s64"
        paddingBottom="s16"
      >
        <Title
          title={i18n.t('budgets.landing.take_control_block.title')}
          description={i18n.t('budgets.landing.take_control_block.description')}
          centered
        />
        <Button.Router
          to={navigation.expenses.budgets.list.new.fullPath()}
          onClick={handleButtonClick}
        >
          {i18n.t('budgets.landing.take_control_block.cta')}
        </Button.Router>
      </Box>

      <HalfWidthBlock
        content={
          <TitleWrapper>
            <Title
              title={i18n.t('budgets.landing.empower_teams_block.title')}
              description={i18n.t('budgets.landing.empower_teams_block.description')}
            />
          </TitleWrapper>
        }
        content2={<img src={BudgetsEmpowerTeamsImage} alt="" aria-hidden="true" />}
      />
      <HalfWidthBlock
        content={<img src={BudgetsVisibilityImage} alt="" aria-hidden="true" />}
        content2={
          <Box paddingLeft="s64" paddingY="s96" gap="s16">
            <Title
              title={i18n.t('budgets.landing.visibility_block.title')}
              description={i18n.t('budgets.landing.visibility_block.description')}
            />
          </Box>
        }
      />
      <HalfWidthBlock
        content={
          <TitleWrapper>
            <Title
              title={i18n.t('budgets.landing.ownership_block.title')}
              description={i18n.t('budgets.landing.ownership_block.description')}
            />
          </TitleWrapper>
        }
        content2={<img src={BudgetsPlanAndControlImage} alt="" aria-hidden="true" />}
      />
      <HalfWidthBlock
        content={<img src={BudgetsColaborationImage} alt="" aria-hidden="true" />}
        content2={
          <Box paddingLeft="s64" paddingY="s96" gap="s16">
            <Title
              title={i18n.t('budgets.landing.collaboration_block.title')}
              description={i18n.t('budgets.landing.collaboration_block.description')}
            />
          </Box>
        }
      />
      <Box
        flexDirection="column"
        gap="s12"
        textAlign="center"
        alignItems="center"
        justifyContent="center"
        paddingTop="s32"
        paddingBottom="s16"
      >
        <Title title={i18n.t('budgets.landing.financial_potential_block.title')} centered />
        <Button.Router
          to={navigation.expenses.budgets.list.new.fullPath()}
          onClick={handleButtonClick}
        >
          {i18n.t('budgets.landing.financial_potential_block.cta')}
        </Button.Router>
      </Box>
      <Box
        flexDirection="row"
        gap="s6"
        textAlign="center"
        alignItems="center"
        justifyContent="center"
      >
        <Icon.Medium icon="info-circle-line" color="grey800" />
        <Text.Normal>{i18n.t('budgets.landing.learn_more_block.description')}</Text.Normal>
        <Link.Href href={HELP_CENTER_URL} target="_blank">
          {i18n.t('budgets.landing.learn_more_block.cta')}
        </Link.Href>
      </Box>
    </Box>
  )
}

export default BudgetsLanding
